var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./SubmissionPopup.jinja');
require('./SubmissionPopup.less');

var SubmissionForm = require('submissions/components/SubmissionForm/SubmissionForm');
var SubmissionFormCancel = require('submissions/components/SubmissionFormCancel/SubmissionFormCancel');
var SubmissionFormSaveDraft = require('submissions/components/SubmissionFormSaveDraft/SubmissionFormSaveDraft');


module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
        'click .SubmissionPopup-buttonsCancel': 'onCancelClick',
        'click .SubmissionPopup-buttonsSaveDraft': 'onSaveDraftClick',
        'click .SubmissionPopup-buttonsSaveDraftUploads': 'onSaveDraftClick',
        'click .SubmissionPopup-buttonsSubmit': 'onSubmitClick'
    }, BasePopup.prototype.baseEvents),


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'SubmissionForm': {selector: '.SubmissionForm', viewConstructor: SubmissionForm},
        'SubmissionFormCancel': {selector: '.SubmissionFormCancel', viewConstructor: SubmissionFormCancel},
        'SubmissionFormSaveDraft': {selector: '.SubmissionFormSaveDraft', viewConstructor: SubmissionFormSaveDraft}
    },


    apiUrl: function () {
        if (this.id) {
            return Urls['submissions:api:submission'](this.category, this.id, 'json');
        } else {
            return Urls['submissions:api:submission-create'](this.category);
        }
    },


    sendUrl: function (action) {
        if (this.id) {
            return Urls['submissions:api:submission'](this.category, this.id, 'json') + '?action=' + action;
        } else {
            return Urls['submissions:api:submission-create'](this.category) + '?action=' + action;
        }
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'sendUrl', 'apiUrl');

        this.category = options.category;
        this.id = options.id;
        this.onlyUploads = options.onlyUploads;

        console.log('INIT', this.id);

        //disable cache for apiUrl (to update content after draft save)
        this.disableCache = true;

        BasePopup.prototype.initialize.call(this, options);
    },


    renderData: function () {
        this.data.onlyUploads = this.onlyUploads;

        return {
            popup: this.data || {}
        };
    },


    viewsRegistration: function () {
        BasePopup.prototype.viewsRegistration.call(this);

        this.form = this.getView('SubmissionForm');
        this.cancel = this.getView('SubmissionFormCancel');
        this.saveDraft = this.getView('SubmissionFormSaveDraft');
    },


    close: function () {
        if (this.form && this.form.hasChanges()) {
            this.cancel && this.cancel.show({
                cb: function (confirmed) {
                    if (confirmed) {
                        BasePopup.prototype.close.call(this);
                    }
                }.bind(this)
            });
        } else {
            BasePopup.prototype.close.call(this);
        }
    },


    onCancelClick: function () {
        this.close();
    },


    getNewContributors: function (oldList, newList) {
        var oldIds = {};

        _.each(oldList, function (item) {
            if (item.id) {
                oldIds[item.id] = true;
            }
        });

        var newContributors = [];

        _.each(newList, function (item) {
            //this contributor is new (has no id before save)
            if (!oldIds[item.id]) {
                newContributors.push(item.email);
            }
        });

        return newContributors;
    },


    onSaveDraftClick: function () {
        if (!this.form) return;

        var data = this.form.getFormData();

        var $button = this.$('.SubmissionPopup-buttonsSaveDraft, .SubmissionPopup-buttonsSaveDraftUploads');

        $button.addClass('Button--loading');

        this.saveXhr && this.saveXhr.abort();

        this.saveXhr = $.ajax({
            url: this.sendUrl('save'),
            method: this.id ? 'PATCH' : 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
            success: function (responseData) {
                $button.removeClass('Button--loading');

                var contributors = this.getNewContributors(data.contributors, responseData.contributors);

                this.saveDraft && this.saveDraft.show({
                    contributors: contributors,
                    cb: function (confirmed) {
                        if (!this.id) {
                            this.id = responseData.id;

                            //change url to newly created id (and recreate popup with updated data)
                            Backbone.history.navigate(Urls['submissions:submission-popup'](this.category, this.id), {trigger: 'true'});
                        } else {
                            //reload page without url change (to recreate popup with updated data)
                            Backbone.history.loadUrl(Backbone.history.fragment);
                        }
                    }.bind(this)
                });

                app.vent.trigger('need-reload', 'submissions');// refresh submissions page on popup close
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Error ' + e.status + ': ' + e.statusText);
                }

                console.log('error', arguments);
            },
            context: this
        });


        this.form.resetHasChanges();
    },


    onSubmitClick: function () {
        if (!this.form) return;

        if (!this.form.checkRequired()) return;

        var data = this.form.getFormData();


        var $button = this.$('.SubmissionPopup-buttonsSubmit');

        $button.addClass('Button--loading');

        this.submitXhr && this.submitXhr.abort();

        this.submitXhr = $.ajax({
            url: this.sendUrl('submit'),
            method: this.id ? 'PATCH' : 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
            success: function (responseData) {
                $button.removeClass('Button--loading');

                this.id = responseData.id;

                if (window.localStorage) {
                    var contributors = this.getNewContributors(data.contributors, responseData.contributors);

                    //for uploads only data.title is undefined
                    localStorage.setItem('submitted', data.title || this.$('.SubmissionPopup-header-caption').text());

                    localStorage.setItem('submittedContributors', JSON.stringify(contributors));
                }

                window.location.href = Urls['submissions:submissions']();
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Error ' + e.status + ': ' + e.statusText);
                }

                console.log('error', arguments);
            },
            context: this
        });


        this.form.resetHasChanges();
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/pages/SubmissionPopup/SubmissionPopup.js
// module id = 136
// module chunks = 0